//types and classes
import type { $TSFixMe } from '@calefy-inc/utilityTypes';
import { BasicAddress } from '../../../../Typescript';
import { QuoteWizardAnswerInstance } from '../../../QuoteWizard/classes';

export const primaryAddressRegex = /^primary.address$/i;

const searchFormStateArrayForPrimaryAddress = (
  answersArray: Array<QuoteWizardAnswerInstance>,
): BasicAddress | undefined => {
  if (answersArray.length === 0) {
    return undefined;
  }
  for (let answersObject of answersArray) {
    const foundInAnswer = searchFormStateObjectForPrimaryAddress(answersObject);
    if (foundInAnswer) {
      return foundInAnswer;
    }
  }
  return undefined;
};

const searchFormStateObjectForPrimaryAddress = (
  answersObject: object,
): BasicAddress | undefined => {
  // return {
  //   address: 'abc123',
  //   city: 'test city',
  //   postal: 'abc-123',
  //   province: 'test province',
  // };
  if (!answersObject || Object.keys(answersObject).length === 0) {
    return;
  }
  for (let key of Object.keys(answersObject)) {
    if (primaryAddressRegex.exec(key)) {
      // @ts-expect-error
      let addressAnswer = answersObject[key];
      if (Array.isArray(addressAnswer)) {
        addressAnswer = addressAnswer[0];
      }
      const primaryAddress = {
        address: addressAnswer['address'],
        city: addressAnswer['city'],
        province: addressAnswer['province'],
        postal: addressAnswer['postalCode'] || addressAnswer['postal'],
      };
      return primaryAddress;
    }
    // @ts-expect-error
    if (Array.isArray(answersObject[key])) {
      const foundInAnswer = searchFormStateArrayForPrimaryAddress(
        // @ts-expect-error
        answersObject[key],
      );
      if (foundInAnswer) {
        return foundInAnswer;
      }
    } else if (
      // @ts-expect-error
      typeof answersObject[key] === 'object' &&
      // @ts-expect-error
      answersObject[key] !== null
    ) {
      const foundInAnswer = searchFormStateObjectForPrimaryAddress(
        // @ts-expect-error
        answersObject[key],
      );
      if (foundInAnswer) {
        return foundInAnswer;
      }
    }
  }
  return undefined;
};

export const getPrimaryAddressFromFormStateAnswers = (
  answers: $TSFixMe,
): BasicAddress | undefined => {
  if (!answers || Object.keys(answers).length === 0) {
    return;
  }
  for (let key of Object.keys(answers)) {
    if (primaryAddressRegex.exec(key)) {
      let primaryAddress: BasicAddress;
      if (Array.isArray(answers[key])) {
        primaryAddress = {
          address: answers[key][0]['address'],
          city: answers[key][0]['city'],
          province: answers[key][0]['province'],
          postal: answers[key][0]['postal'],
        };
      } else {
        primaryAddress = {
          address: answers[key]['address'],
          city: answers[key]['city'],
          province: answers[key]['province'],
          postal: answers[key]['postal'],
        };
      }
      return primaryAddress;
    }
    if (Array.isArray(answers[key])) {
      const foundInAnswer = searchFormStateArrayForPrimaryAddress(answers[key]);
      if (foundInAnswer) {
        return foundInAnswer;
      }
    } else if (typeof answers[key] === 'object' && answers[key] !== null) {
      const foundInAnswer = searchFormStateObjectForPrimaryAddress(
        answers[key],
      );
      if (foundInAnswer) {
        return foundInAnswer;
      }
    }
  }
  return undefined;
};
